import * as React from "react";
import { forwardRef } from "react";
const SvgIcPlayerNext32 = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 32, height: 32, viewBox: "0 0 32 32", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("g", { id: "icPlayer-next-32" }, /* @__PURE__ */ React.createElement("path", { id: "Vector", fillRule: "evenodd", clipRule: "evenodd", d: "M22 7L21 8V14.3507L8.5 7.13379L7 7.99981V22.8357L8.5 23.7018L21 16.4849V23L22 24H24L25 23V8L24 7H22Z", fill: "currentColor" })));
const ForwardRef = forwardRef(SvgIcPlayerNext32);
export { ForwardRef as ReactComponent };
